import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import CallEndIcon from '@mui/icons-material/CallEnd';
import PhoneIcon from '@mui/icons-material/Phone';

/**
 * CallControls Component
 * Provides mute, video toggle, and hang up controls for video calls
 */
const CallControls = ({
  isMuted,
  isVideoEnabled,
  callType,
  onToggleMute,
  onToggleVideo,
  onHangUp,
  disabled = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        p: 2,
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 4,
        backdropFilter: 'blur(10px)',
      }}
    >
      {/* Mute/Unmute Button */}
      <Tooltip title={isMuted ? 'Unmute' : 'Mute'}>
        <IconButton
          onClick={onToggleMute}
          disabled={disabled}
          sx={{
            bgcolor: isMuted ? 'error.main' : 'rgba(255, 255, 255, 0.1)',
            color: 'white',
            '&:hover': {
              bgcolor: isMuted ? 'error.dark' : 'rgba(255, 255, 255, 0.2)',
            },
            width: 56,
            height: 56,
          }}
        >
          {isMuted ? <MicOffIcon /> : <MicIcon />}
        </IconButton>
      </Tooltip>

      {/* Video Toggle Button (only for video calls) */}
      {callType === 'video' && (
        <Tooltip title={isVideoEnabled ? 'Turn off camera' : 'Turn on camera'}>
          <IconButton
            onClick={onToggleVideo}
            disabled={disabled}
            sx={{
              bgcolor: !isVideoEnabled ? 'error.main' : 'rgba(255, 255, 255, 0.1)',
              color: 'white',
              '&:hover': {
                bgcolor: !isVideoEnabled ? 'error.dark' : 'rgba(255, 255, 255, 0.2)',
              },
              width: 56,
              height: 56,
            }}
          >
            {isVideoEnabled ? <VideocamIcon /> : <VideocamOffIcon />}
          </IconButton>
        </Tooltip>
      )}

      {/* Hang Up Button */}
      <Tooltip title="End call">
        <IconButton
          onClick={onHangUp}
          disabled={disabled}
          sx={{
            bgcolor: 'error.main',
            color: 'white',
            '&:hover': {
              bgcolor: 'error.dark',
            },
            width: 64,
            height: 64,
          }}
        >
          {callType === 'audio' ? <PhoneIcon /> : <CallEndIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CallControls;

